/* @flow */

import type { PLAYING_HISTORY_ARRAY_TYPE } from '../../libs/netgemLibrary/v8/types/PlayingHistory';
import type { KeyValuePair } from '../jsHelpers/types';

const generateHash = (str: string): number => {
  const HASH_SHIFT = 5; // Multiplication by 2, 5 times
  let hash = 0;

  for (const char of str.split('')) {
    hash = (hash << HASH_SHIFT) - hash + char.charCodeAt(0);
    hash |= 0; // Constrain to 32bit integer
  }

  return hash;
};

const getHashAndTimestampLookUpFromDates = (items: PLAYING_HISTORY_ARRAY_TYPE): { hash: number, timestampLookUp: KeyValuePair<number> } | null => {
  if (!items || items.length === 0) {
    return null;
  }

  const timestampLookUp: KeyValuePair<number> = {};
  const hashSources: Array<string> = [];

  items.forEach(({ profiles, programId }) => {
    let mostRecentDate: number = 0;
    Object.values(profiles).forEach(({ date: dateIso }) => {
      hashSources.push(dateIso);
      const date = Date.parse(dateIso);

      if (date > mostRecentDate) {
        mostRecentDate = date;
      }
    });

    timestampLookUp[programId] = mostRecentDate;
  });

  return { hash: generateHash(hashSources.join()), timestampLookUp };
};

export { getHashAndTimestampLookUpFromDates };
